// components/SavePresetDialog.tsx
import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Input,
  FormLabel,
  Button,
  VStack,
  Box,
  Text,
  Icon,
} from "@chakra-ui/react";
import { Save } from "lucide-react";

interface SavePresetDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, description?: string) => void;
  isLoading?: boolean;
}

export const SavePresetDialog: React.FC<SavePresetDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  isLoading = false,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleSave = () => {
    if (!name.trim()) return;
    onSave(name.trim(), description.trim() || undefined);
    setName("");
    setDescription("");
  };

  const handleClose = () => {
    setName("");
    setDescription("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Save Custom Preset</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <Box w="full">
              <FormLabel>Name</FormLabel>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="My Custom Preset"
                autoFocus
              />
              <Text fontSize="xs" color="gray.500" mt={1}>
                Give your preset a memorable name.
              </Text>
            </Box>
            <Box w="full">
              <FormLabel>Description</FormLabel>
              <Input
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="A custom algorithm configuration"
              />
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button 
            variant="outline" 
            mr={3} 
            onClick={handleClose}
            size="sm"
            h="36px"
            minW="90px"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            leftIcon={<Icon as={Save} />}
            onClick={handleSave}
            isDisabled={!name.trim() || isLoading}
            isLoading={isLoading}
            colorScheme="green"
            size="sm"
            h="36px"
            minW="90px"
          >
            Save As...
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};